export interface FreeDeliveryConfig {
  cart_minimum: number | null;
  id: number;
  store_id: number;
}

export const applicableFreeDeliveryConfig = ({
  discountedSubtotal,
  freeDeliveryConfigs,
}: {
  discountedSubtotal?: number;
  freeDeliveryConfigs?: Readonly<FreeDeliveryConfig[]>;
}) =>
  (freeDeliveryConfigs ?? []).find((freeDeliveryConfig) =>
    isEligibleForFreeDeliveryConfig({
      freeDeliveryConfig,
      discountedSubtotal,
    })
  );

export const isEligibleForFreeDeliveryConfig = ({
  discountedSubtotal = 0,
  freeDeliveryConfig,
}: {
  discountedSubtotal?: number;
  freeDeliveryConfig?: FreeDeliveryConfig;
}): boolean => {
  const subtotalMeetsCartMinimum = freeDeliveryConfig?.cart_minimum
    ? discountedSubtotal >= freeDeliveryConfig?.cart_minimum
    : true;

  return subtotalMeetsCartMinimum;
};
